/*
 * Copyright (C) 2025 Musarubra US LLC.  All Rights Reserved.
 */

import { WidgetContext } from './widget-context-base';
import { iamLogin } from '../main';
import { iam } from '../iam';
import { WidgetElements } from '../elements/widget-elements-base';

export class AccountUnlockWidgetContext extends WidgetContext {
  constructor(elements: WidgetElements) {
    super(elements);
  }

  public override localize() {
    iamLogin.localizeElement('sub-header', 'unlockAccountSubhead');
    iamLogin.localizeElement(this.elements.getAccountRecoveryUsernameLabel(), { stringKey: 'email', isWidgetElement: true });
    iamLogin.localizeElement(this.elements.getEmailButton(), { stringKey: 'sendEmail', isWidgetElement: true });
    iamLogin.localizeElement('needHelpSigningIn', 'needHelpSigningIn');
  }

  public override initialize() {
    // login.html's unlock account screen
    if (iam.settings.debug) console.log('initializing account unlock widget');
    document.getElementById('dont-have-a-mvision').style.display = 'none';
    // show footer
    iamLogin.page.showCommonFields(['post-okta']);
    iamLogin.page.initializeCommon();
  }

  public override setInitialFocus() {
    const field = this.elements.getAccountRecoveryUsernameField();
    if (field && !field.disabled) {
      field.focus();
    }
  }

  public override validateForm() {
    // disable submit button if the value isn't a valid email address
    this.elements.getEmailButton().disabled = !iamLogin.isEmailAddressValid(this.elements.getAccountRecoveryUsernameField().value);
  }
}
